import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M746.666667,1374.30933 L746.666667,545.936 L1437.01333,960.122667 L746.666667,1374.30933 Z M1879.04,321.616 C1278.93333,178.149333 640.64,178.149333 40.96,321.616 L0,331.429333 L0,1588.92267 L40.96,1598.736 C341.013333,1670.416 650.24,1706.78933 960,1706.78933 C1269.86667,1706.78933 1579.2,1670.416 1879.04,1598.736 L1920,1588.92267 L1920,331.429333 L1879.04,321.616 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconFilmstripSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconFilmstripSolid, _Component);

  var _super = _createSuper(IconFilmstripSolid);

  function IconFilmstripSolid() {
    _classCallCheck(this, IconFilmstripSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconFilmstripSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconFilmstrip",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconFilmstripSolid.displayName = "IconFilmstripSolid";
  return IconFilmstripSolid;
}(Component);

IconFilmstripSolid.glyphName = 'filmstrip';
IconFilmstripSolid.variant = 'Solid';
IconFilmstripSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconFilmstripSolid;
export { IconFilmstripSolid };